import React from 'react';

function ManagesFinancePage() {
    return <div>ManagesFinancePage</div>;
}

export default ManagesFinancePage;
